<template>
    <modal @close="$emit('close')">
        <template slot="header">
            Campaign creator -
            <button type="button" class="btn btn-primary" :disabled="step == 0" @click="step--">Back</button>
            <button type="button" class="btn btn-primary" :disabled="!canNext" @click="setNextStep">Next</button>
            <button type="button" class="btn btn-primary" :disabled="step !== 1" @click="save()">Save</button>
            <button class="btn btn-link" @click="$emit('close')">Cancel</button>
        </template>
        <div class="alert alert-danger" v-if="err">{{ err }}</div>
        <div class="alert alert-success" v-if="success">{{ success }}</div>
        <div class="row" v-if="step === 0">
            <div class="col-4">
                <div class="form-group row">
                    <div class="col-lg-12">
                        <label class="col-form-label col-lg-12">List of campaign template names (one per line)</label>
                        <ace-editor :editor-id="'step1_domains'" @change-content="contentChangedStep1Domains"
                            :content="step1_domains || ''" lang="text" theme="monokai"
                            v-bind:style="{ 'width': '100%', height: '300px' }"></ace-editor>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group row">
                    <div class="col-lg-12">
                        <label class="col-form-label col-lg-12">List of contact lists by name (one per line)</label>
                        <ace-editor :editor-id="'step1_lists'" @change-content="contentChangedStep1Lists"
                            :content="step1_lists || ''" lang="text" theme="monokai"
                            v-bind:style="{ 'width': '100%', height: '300px' }"></ace-editor>
                    </div>
                </div>
            </div>



        </div>

        <div class="row" v-if="step === 1">
            <div class="form-group row">
                <label for="picker1" class="col-sm-3 control-label">
                    Automation:
                </label>
                <div class="col-lg-8" v-if="form.automation !== null">
                    <input type="number" class="form-control" v-model="form.automation.wait_seconds" />
                    <small>Number of seconds to wait before sending email (greater than 0)</small><br />

                    <input type="checkbox" name="sendon" value="true" id="send_on_click"
                        v-model="form.automation.send_on_click"> <label for="send_on_click">Send on click</label><br />
                    <input type="checkbox" name="sendon" value="true" id="send_on_open"
                        v-model="form.automation.send_on_open">
                    <label for="send_on_open">Send on open</label><br />

                    Template:
                    <div class="form-check form-check-inline">
                        <multiselect v-model="form.automation.template" tag-placeholder=""
                            @search-change="templateFindByName" :searchable="true" :loading="loadingTypeahead"
                            placeholder="Search for a template TAG" label="name" track-by="_id"
                            :options="templateList || []" :multiple="false"></multiselect>
                    </div>
                </div>
                <div style="margin-left:20px" class="col-lg-3">
                    <button v-if="form.automation == null" @click="fillAutomation" class="btn btn-sm btn-primary">Enable
                        automation</button>
                    <button v-else @click="form.automation = null" class="btn btn-sm btn-danger">Disable
                        automation</button>
                </div>
            </div>
            <div class="col-12">
                <h2>A list of campaigns to be created</h2>
                <div v-for="c, i in campaigns" style="border-bottom: 1px solid rgba(0,0,0,.2)">
                    <template v-if="(i == 0 || campaigns[i - 1].batch !== c.batch)">
                        <div style="margin-top:15px; font-size: 14px;">Round #{{ c.batch + 1 }}</div>
                    </template>
                    <strong>Name</strong>: {{ c.name }},
                    <strong>Start at</strong>: {{ c.start_at | estTime }},
                    <strong>Domain</strong>: {{ c.domain.domain }},
                    <strong>Mailer</strong>: {{ c.mailer.name }} ({{ c.mailer.provider }}: {{ c.mailer.status || "-"
                    }}),
                    <strong>Contact list</strong>: {{ c.contact_list.name }},
                    <strong>Campaign Template</strong>: {{ c.campaign_template.name }},
                    <strong>Message Template</strong>: {{ c.template.name }}
                    <template v-if="c.error">
                        <br /><strong>{{ c.error }}</strong>
                    </template>
                    <template v-if="c.success">
                        <br /><strong>Campaign created successfully</strong>
                    </template>
                    <template v-if="c.validated">
                        <br /><strong>Campaign validated</strong>
                    </template>
                </div>
            </div>

        </div>
        <div class="col-12">
            <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                <div class="alert alert-danger" v-if="err">{{ err }}</div>
                <div class="alert alert-success" v-if="success">{{ success }}</div>
                <div class="form-group row">
                    <label class="col-form-label col-lg-12">
                        <button type="button" class="btn btn-primary" :disabled="step == 0"
                            @click="step--">Back</button>
                        <button type="button" class="btn btn-primary" :disabled="!canNext"
                            @click="setNextStep">Next</button>
                        <button type="button" class="btn btn-primary" :disabled="step !== 1"
                            @click="save()">Save</button>
                        <button class="btn btn-link" @click="$emit('close')">Cancel</button>
                    </label>
                </div>
            </fieldset>
        </div>
    </modal>
</template>
<script>
import modal from '../common/Modal.vue'
import aceEditor from '../common/Ace.js'
import datetime from 'vuejs-datetimepicker';
import moment from 'moment'

let dbtm

export default {
    components: { modal, aceEditor, datetime },
    props: {
        id: null,
    },
    data() {
        return {
            step: 0,
            show_help: false,
            fullscreen: false,
            err: null,
            success: null,
            loading: false,

            mailer_account: [],
            list: [],
            templateList: [],
            domain: [],
            name_templates: [],
            loadingTypeahead: false,
            campaign_tags: [],
            contact_list_tags: [],

            // Campaign template functionality
            campaign_templates: [],

            campaigns: [],

            step1_lists: '',
            step1_domains: '',

            form_common: {
                campaigns_per_domain: 0,
            },
            loadingTypeahead: false,
            templateList: [],

            round_size: 0,

            form: {
                send_limit: 0,
                automation: null,
            },

        }
    },
    methods: {
        setNextStep: async function () {
            this.err = null
            this.loading = true
            try {
                if (this.step === 0) {
                    let res = await this.validate1Step()
                    this.generateStep2(res)
                }
                this.step++
            } catch (e) {
                console.log('error', e)
                this.err = e
            }
            this.loading = false
        },
        templateFindByName(query) {
            if (query === '') {
                return
            }
            this.templateList = []

            this.loadingTypeahead = true
            clearTimeout(dbtm)
            dbtm = setTimeout(() => {
                this.$api.getReq('template?query=' + query).then(res => {
                    this.loadingTypeahead = false
                    this.templateList = res.body.data
                })
            }, 500)
        },

        fillAutomation: function () {
            this.form.automation = {
                wait_seconds: 0,
                send_on_click: false,
                send_on_open: false,
                template: null
            }
        },
        generateStep2: function (res) {
            let { campaign_templates, contact_lists } = res
            let campaigns = []

            function pad(num, size) {
                num = num.toString();
                while (num.length < size) num = "0" + num;
                return num;
            }

            // Helper function to parse start_hours and create start date for a template
            function createStartDateForTemplate(template) {
                let startDate = moment().utcOffset(-5 * 60) // EST timezone
                if (template.start_hours !== undefined) {
                    // Parse the new time format (e.g., "5:20", "5.20", or legacy number format)
                    let hours = 0
                    let minutes = 0

                    if (typeof template.start_hours === 'string') {
                        // Handle string formats like "5:20" or "5.20"
                        const timeStr = template.start_hours.toString()
                        if (timeStr.includes(':')) {
                            const parts = timeStr.split(':')
                            hours = parseInt(parts[0]) || 0
                            minutes = parseInt(parts[1]) || 0
                        } else if (timeStr.includes('.')) {
                            const parts = timeStr.split('.')
                            hours = parseInt(parts[0]) || 0
                            minutes = parseInt(parts[1]) || 0
                        } else {
                            // Handle string numbers like "5"
                            hours = parseInt(timeStr) || 0
                            minutes = 0
                        }
                    } else {
                        // Handle legacy numeric format
                        hours = parseInt(template.start_hours) || 0
                        minutes = 0
                    }

                    startDate.hour(hours).minute(minutes).second(0)
                    // If the time has passed today, set it for tomorrow
                    if (startDate.isBefore(moment().utcOffset(-5 * 60))) {
                        startDate.add(1, 'day')
                    }
                }
                return startDate
            }

            // Pre-calculate template assignments for consecutive distribution
            let lists_per_template = Math.floor(contact_lists.length / campaign_templates.length)
            let extra = contact_lists.length % campaign_templates.length
            let template_assignments = []
            let start_idx = 0
            for (let t = 0; t < campaign_templates.length; t++) {
                let num_lists = lists_per_template + (t < extra ? 1 : 0)
                for (let j = 0; j < num_lists; j++) {
                    template_assignments[start_idx + j] = t
                }
                start_idx += num_lists
            }

            // Track current time for each batch (template)
            let batchCurrentTimes = campaign_templates.map(template => createStartDateForTemplate(template))

            // Create one campaign per contact list, using consecutive template assignments
            for (let i = 0; i < contact_lists.length; i++) {
                let campaign_template_index = template_assignments[i]
                let campaign_template = campaign_templates[campaign_template_index]
                let domainIndex = i % campaign_template.verified_domains.length
                let domain = campaign_template.verified_domains[domainIndex]

                // Use the current time for this batch
                let dt = batchCurrentTimes[campaign_template_index].clone()

                campaigns.push({
                    batch: campaign_template_index, // Set proper batch number based on template
                    name: [domain.domain, domain.mailer_account.name, dt.format('DD MMMM YYYY'), "#" + pad(i + 1, 3)].join(" - "),
                    start_at: dt.toDate(),
                    domain: {
                        domain: domain.domain,
                        _id: domain._id
                    },
                    template: {
                        name: campaign_template.message_template.name,
                        _id: campaign_template.message_template._id
                    },
                    campaign_template: {
                        name: campaign_template.name,
                        _id: campaign_template._id
                    },
                    error: '',
                    success: false,
                    mailer: domain.mailer_account,
                    contact_list: {
                        name: contact_lists[i].name,
                        _id: contact_lists[i]._id,
                    }
                })

                // Advance the time for this batch
                batchCurrentTimes[campaign_template_index].add(campaign_template.time_interval || 1, 'minutes')
            }

            this.campaigns = campaigns
        },
        getFirstScheduledAt: function () {
            return moment().utcOffset(-5 * 60)
        },
        contentChangedStep1Domains(c) {
            this.step1_domains = c
        },
        contentChangedStep1Lists(c) {
            this.step1_lists = c
        },
        templateFind(query) {
            if (query === '') {
                return
            }
            this.templateList = []

            this.loadingTypeahead = true
            clearTimeout(dbtm)
            dbtm = setTimeout(() => {
                this.$api.getReq('template_tags?query=' + query).then(res => {
                    this.loadingTypeahead = false
                    this.templateList = res.body.data
                })
            }, 500)
        },
        parseStep1: function () {
            let campaign_templates = this.step1_domains.split("\n").filter(l => l.length).map(row => row.trim())
            let contact_lists = this.step1_lists.split("\n").filter(l => l.length).map(row => row.trim())

            return { campaign_templates, contact_lists }
        },
        async validate1Step() {
            let parsed = this.parseStep1()

            // Check if campaign templates exist
            let missing_campaign_templates = []
            parsed.campaign_templates.forEach(name => {
                let found = this.campaign_templates.find(ct => ct.name === name)
                if (!found) {
                    missing_campaign_templates.push(name)
                }
            })
            if (missing_campaign_templates.length) {
                throw new Error(`Missing campaign templates: ${missing_campaign_templates.join(', ')}.`)
            }

            // Fetch full campaign template data
            let campaign_templates_full = []
            for (let name of parsed.campaign_templates) {
                let ct = this.campaign_templates.find(ct => ct.name === name)
                try {
                    const res = await this.$api.getReq(`campaign_template/${ct._id}`)
                    campaign_templates_full.push(res.body.data)
                } catch (e) {
                    throw new Error(`Error loading campaign template ${name}: ${e.body && e.body.error || e.message}`)
                }
            }

            // Collect all domains from campaign templates
            let all_domains = []
            campaign_templates_full.forEach(ct => {
                let domains = ct.domains_text.split("\n").filter(l => l.length).map(row => row.trim())
                all_domains.push(...domains)
            })
            all_domains = [...new Set(all_domains)] // unique

            // Verify domains and contact lists
            return new Promise((resolve, reject) => {
                this.$api.postReq("verify", { domains: all_domains, contact_lists: parsed.contact_lists }).then(res => {
                    let msg = ''
                    if (res.data.result.missing_domains.length) {
                        msg += `Missing domains or not validated: ${res.data.result.missing_domains.join(', ')}. `
                    }
                    if (res.data.result.missing_lists.length) {
                        msg += `Missing contact lists: ${res.data.result.missing_lists.join(', ')}. `
                    }

                    if (msg) {
                        reject(msg)
                    } else {
                        // we're ordering the results in the same way they were provided
                        let dictDomains = {}
                        let dictLists = {}
                        res.data.result.domains.forEach(d => { dictDomains[d.domain] = d })
                        res.data.result.lists.forEach(d => { dictLists[d.name] = d })

                        // Attach verified domains to campaign templates
                        campaign_templates_full.forEach(ct => {
                            ct.verified_domains = ct.domains_text.split("\n").filter(l => l.length).map(row => row.trim()).map(d => dictDomains[d])
                        })

                        resolve({
                            campaign_templates: campaign_templates_full,
                            contact_lists: parsed.contact_lists.map(d => dictLists[d]),
                        })
                    }
                })
            })
        },
        async save(_, cb) {

            this.loading = true

            let anyErr = false

            for (let i = 0; i < this.campaigns.length; i++) {
                this.campaigns[i].error = null
                try {
                    await this._saveOne(this.campaigns[i], true)
                    this.campaigns[i].validated = true

                } catch (e) {
                    this.campaigns[i].error = e.message || e
                    this.campaign[i].validated = false
                    anyErr = true
                }
            }

            if (anyErr) {
                return
            }

            for (let i = 0; i < this.campaigns.length; i++) {
                this.campaigns[i].error = null
                try {
                    await this._saveOne(this.campaigns[i], false)
                    await new Promise(resolve => setTimeout(resolve, 200))
                    this.campaigns[i].success = true

                } catch (e) {
                    this.campaigns[i].error = e.message || e
                    this.campaign[i].validated = false
                    anyErr = true
                }
            }

            this.loading = false

            if (!anyErr) {
                this.$emit('reload')
                this.$emit('close')
            }
        },
        async _saveOne(campaign, validate) {

            let automation = undefined
            if (this.form.automation) {
                automation = JSON.parse(JSON.stringify(this.form.automation))
                if (this.form.automation.template) {
                    automation.template = this.form.automation.template._id
                }
            }

            let f = {
                name: campaign.name,
                scheduled_at: campaign.start_at,
                list: campaign.contact_list._id,
                domain: campaign.domain._id,
                mailer_account: campaign.mailer._id,
                message_template_id: campaign.template._id,
                automation
            }

            return new Promise((resolve, reject) => {
                this.$api.postReq('campaign' + (validate && '?skip_saving=1' || ''), f).then(res => {
                    resolve()
                }).catch(res => {
                    reject(res.body.error)
                })
            })
        },
        async validate(_, cb) {
            this.loading = true

            // validate here

            this.loading = false

            return true
        },
        // Campaign template methods
        async loadCampaignTemplates() {
            try {
                const res = await this.$api.getReq('campaign_template', { limit: 99999 })
                this.campaign_templates = res.body.data || []
            } catch (e) {
                console.error('Error loading campaign templates:', e)
            }
        },
    },
    watch: {
    },
    computed: {
        schedulePlaceholder() {
            return moment().add(4, 'hour')
        },
        canTestEmail() {

            if (this.id === null) {
                return false
            }

            if (this.testEmail.indexOf('@') <= 0) {
                return false
            }

            if (this.form.message_templates.length === 0) {
                if (!this.form.mailer_account || !this.form.domain) {
                    return false
                }
            } else {
                return true
            }

            return true
        },
        canNext() {
            switch (this.step) {
                case 0:
                    return this.step1Domains.length > 0 && this.step1Lists.length > 0
                case 1:
                    return false
            }
        },
        step1Domains() {
            return this.step1_domains.split("\n").map(s => s.trim()).filter(s => s)
        },
        step1Lists() {
            return this.step1_lists.split("\n").map(s => s.trim()).filter(s => s)
        },
        step1Subjects() {
            return this.step1_subjects.split("\n").map(s => s.trim()).filter(s => s)
        },
        step1ErrorsForm() {
            let dc = this.step1Domains.length
            let lc = this.step1Lists.length
            let sc = this.step1Subjects.length

            // if (dc > 0 && (dc !== lc || dc !== sc || lc !== sc)) {
            //     return 'Fill the same number of rows in every column'
            // }
            return ''
        },
        step1Errors() {
            // if (this.step1ErrorsForm) {
            //     return this.step1ErrorsForm
            // }

            // if (this.verifiedLists && (this.verifiedLists.missing_domains || this.verifiedLists.missing_lists)) {
            //     let msg = ''
            //     if (this.verifiedLists.missing_domains.length) {
            //         msg += `Missing domains or not validated: ${this.verifiedLists.missing_domains.map(d => {
            //             return d + ` (line #${this.step1Domains.indexOf(d) + 1})`
            //         }).join(', ')} <br/>`
            //     }
            //     if (this.verifiedLists.missing_lists.length) {
            //         msg += `Missing contact lists: ${this.verifiedLists.missing_lists.map(d => {
            //             return d  + `(#${this.step1Lists.indexOf(d) + 1})`
            //         }).join(', ')} <br/>`
            //     }
            //     return msg
            // }

            return ''
        }
    },
    mounted() {
        this.loading = 1

        if (document.location.href.indexOf('localhost') >= 0) {
            this.step1_lists = `foo\nfoo2\nfoo3\nfoo4`
            this.step1_domains = `test template\ntest template2`

            // this.form_common.name = 'ttesst' + new Date()
            // this.form_common.minutes_interval = 10
        }



        this.$api.getReq('campaign_create').then(res => {
            this.mailer_account = res.body.data.mailer_account
            this.name_templates = res.body.data.name_templates.map(n => {
                n.name = n._id
                return n
            })
            this.form.send_limit = res.body.data.default_throttle || 0
            this.campaign_tags = res.body.data.campaign_tags
            this.contact_list_tags = res.body.data.contact_list_tags
            this.loading--

        })

        // Load campaign templates
        this.loadCampaignTemplates()

    }
}
</script>
<style>
.modal-full {
    height: 95% !important;
    top: 0;
    width: 99% !important;
}

.ifrfull {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    z-index: 1000000 !important;
}

div.disabled {
    pointer-events: none;

    /* for "disabled" effect */
    opacity: 0.5;
    background: #CCC;
}
</style>


// WEBPACK FOOTER //
// src/components/modal/MultipleCampaignCreator2.vue